export default function BoardSkeleton() {
  return (
    <div
      className="bg-white dark:bg-maven-gray-800 dark:ring-1 dark:ring-maven-teal-500/40 rounded-lg overflow-hidden"
      style={{ aspectRatio: "3 / 4" }}
    >
      <div className="px-4 py-3 h-full animate-pulse">
        {/* Title skeleton */}
        <div className="h-6 bg-gray-200 dark:bg-white/10 rounded w-2/3 mb-4" />

        {/* Content lines skeleton */}
        <div className="space-y-3">
          <div className="flex items-start gap-2">
            <div className="w-1.5 h-1.5 bg-gray-200 dark:bg-white/10 rounded-full mt-2 shrink-0" />
            <div className="h-4 bg-gray-200 dark:bg-white/10 rounded w-full" />
          </div>
          <div className="flex items-start gap-2">
            <div className="w-1.5 h-1.5 bg-gray-200 dark:bg-white/10 rounded-full mt-2 shrink-0" />
            <div className="h-4 bg-gray-200 dark:bg-white/10 rounded w-5/6" />
          </div>
          <div className="flex items-start gap-2">
            <div className="w-1.5 h-1.5 bg-gray-200 dark:bg-white/10 rounded-full mt-2 shrink-0" />
            <div className="h-4 bg-gray-200 dark:bg-white/10 rounded w-4/5" />
          </div>
          <div className="flex items-start gap-2">
            <div className="w-1.5 h-1.5 bg-gray-200 dark:bg-white/10 rounded-full mt-2 shrink-0" />
            <div className="h-4 bg-gray-200 dark:bg-white/10 rounded w-3/4" />
          </div>
        </div>
      </div>
    </div>
  );
}
